import defectsApi from '../services/api/defectsApi';
import { getInspection, visibleModalToggled } from './inspectionDetail';
import hazardsApi from '../services/api/hazardsApi';
import { responseErrorFormatter } from '../services/http/errors';
import inspectionApi from '../services/api/inspectionApi';
import tagsApi from '../services/api/tagsApi';
import documentApi from '../services/api/documentApi';
import { setAlert } from './alerts';
import { addUploadedPhoto } from './documents';

export const TOGGLE_LOADING = 'EDIT_HAZARD_DEFECTS/TOGGLE_LOADING';
export const FORM_REFRESHED = 'EDIT_HAZARD_DEFECTS/FORM_REFRESHED';
export const FORM_OPTIONS_REFRESHED =
    'EDIT_HAZARD_DEFECTS/FORM_OPTIONS_REFRESHED';
export const DEFECT_SELECTED = 'EDIT_HAZARD_DEFECTS/DEFECT_SELECTED';
export const ADD_DEFECT_HAZARD = 'EDIT_HAZARD_DEFECTS/ADD_DEFECT_HAZARD';
export const DELETE_DEFECT_HAZARD = 'EDIT_HAZARD_DEFECTS/DELETE_DEFECT_HAZARD';
export const UPDATE_DEFECT_HAZARD = 'EDIT_HAZARD_DEFECTS/UPDATE_DEFECT_HAZARD';
export const ADD_DEFECT_TAG = 'EDIT_HAZARD_DEFECTS/ADD_DEFECT_TAG';
export const DELETE_DEFECT_TAG = 'EDIT_HAZARD_DEFECTS/DELETE_DEFECT_TAG';
export const UPDATE_DEFECT_TAG = 'EDIT_HAZARD_DEFECTS/UPDATE_DEFECT_TAG';
export const LOCATION_SELECTED = 'EDIT_LOCATION/LOCATION_SELECTED';
export const UPDATE_ALL_HAZARDS = 'EDIT_HAZARD_DEFECTS/UPDATE_ALL_HAZARDS';
export const UPDATE_ALL_TAGS = 'EDIT_HAZARD_DEFECTS/UPDATE_ALL_TAGS';
export const UPDATE_ALL_DOCUMENT_LABELS =
    'EDIT_HAZARD_DEFECTS/UPDATE_ALL_DOCUMENT_LABELS';
export const UPDATE_ACTION_TYPES = 'EDIT_HAZARD_DEFECTS/UPDATE_ACTION_TYPES';
export const SET_HAZARD = 'EDIT_HAZARD_DEFECTS/SET_HAZARD';

export const formRefreshed = (form) => ({
    type: FORM_REFRESHED,
    form,
});

export const toggleLoading = (isLoading) => ({
    type: TOGGLE_LOADING,
    isLoading,
});

export const formOptionsRefreshed = () => ({
    type: FORM_OPTIONS_REFRESHED,
});

export const defectSelected = (selectedDefect) => ({
    type: DEFECT_SELECTED,
    selectedDefect,
});

export const addDefectHazard = (hazardId) => ({
    type: ADD_DEFECT_HAZARD,
    hazardId,
});

export const deleteDefectHazard = (index) => ({
    type: DELETE_DEFECT_HAZARD,
    index,
});

export const updateDefectHazard = (index, value) => ({
    type: UPDATE_DEFECT_HAZARD,
    index,
    value,
});

export const addDefectTag = (tagId) => ({
    type: ADD_DEFECT_TAG,
    tagId,
});

export const deleteDefectTag = (index) => ({
    type: DELETE_DEFECT_TAG,
    index,
});

export const updateDefectTag = (index, value) => ({
    type: UPDATE_DEFECT_TAG,
    index,
    value,
});

export const locationSelected = (selectedLocation) => ({
    type: LOCATION_SELECTED,
    selectedLocation,
});

export const updateAllHazards = (hazards) => ({
    type: UPDATE_ALL_HAZARDS,
    hazards,
});

export const updateAllTags = (tags) => ({
    type: UPDATE_ALL_TAGS,
    tags,
});

export const updateAllDocumentLabels = (labels) => ({
    type: UPDATE_ALL_DOCUMENT_LABELS,
    labels,
});

export const updateActionTypes = (actionTypes) => ({
    type: UPDATE_ACTION_TYPES,
    actionTypes,
});

export const setHazard = (hazard) => ({
    type: SET_HAZARD,
    hazard,
});

export const getAllHazards = () => async (dispatch) => {
    try {
        dispatch(toggleLoading(true));

        const hazards = (await hazardsApi.getAll()).data.data;

        dispatch(updateAllHazards(hazards));

        dispatch(toggleLoading(false));
    } catch ({ response }) {
        dispatch(setAlert('Error loading all hazards.', 'error'));
    }
};

export const getAllTags = () => async (dispatch) => {
    try {
        dispatch(toggleLoading(true));

        const tags = (await tagsApi.getAll()).data.data;

        dispatch(updateAllTags(tags));

        dispatch(toggleLoading(false));
    } catch ({ response }) {
        dispatch(setAlert('Error loading all tags.', 'error'));
    }
};

export const getAllDocumentLabels = () => async (dispatch) => {
    try {
        dispatch(toggleLoading(true));

        const labels = (await documentApi.getAllLabels()).data.data;

        dispatch(updateAllDocumentLabels(labels));

        dispatch(toggleLoading(false));
    } catch ({ response }) {
        dispatch(setAlert('Error loading all document labels.', 'error'));
    }
};

export const getAllActionTypes = () => async (dispatch) => {
    try {
        dispatch(toggleLoading(true));

        const actionTypes = (await inspectionApi.getActionTypes()).data.data;

        dispatch(updateActionTypes(actionTypes));

        dispatch(toggleLoading(false));
    } catch ({ response }) {
        dispatch(setAlert('Error loading all tags.', 'error'));
    }
};


export const deleteDefect = (defectId) => async (dispatch, getState) => {
    try {
        const { inspection } = getState().pages.inspectionDetail;

        await defectsApi.delete(defectId);
        await dispatch(getInspection(inspection.id));

        dispatch(setAlert('Defect deleted.', 'success'));
    } catch ({ response }) {
        dispatch(setAlert('Failed deleting the defect.', 'error'));
    }
};

export const updateDefect =
    (
        values,
        { setSubmitting, setStatus, resetForm },
        onSuccess,
        selectedDefect
    ) =>
    async (dispatch, getState) => {
        try {
            const { inspection } = getState().pages.inspectionDetail;

            const payload = {
                ...values,
                hazards: selectedDefect.hazards.map((hazard) => hazard.id),
                tags: selectedDefect.tags.map((tag) => tag.id),
                element_id: Number(values.element_id),
            };

            await defectsApi.update(values.id, payload);

            dispatch(visibleModalToggled(null));
            dispatch(getInspection(inspection.id));

            dispatch(setAlert('Survey finding updated.', 'success'));
            setSubmitting(false);

            resetForm();
            onSuccess();
        } catch ({ response }) {
            setSubmitting(false);

            setStatus({
                errors: responseErrorFormatter(response.data.errors),
            });
        }
    };

export const refreshFormOptions = (selectedDefect, isShare) => async (dispatch) => {
    try {
        dispatch(toggleLoading(true));

        dispatch(defectSelected(selectedDefect));

        if (!isShare) {
            await dispatch(getAllHazards());
            await dispatch(getAllActionTypes());
            await dispatch(getAllDocumentLabels());
        }

        const initialForm = {
            initialValues: {
                id: selectedDefect.id,
                element_id: selectedDefect.element_id,
                action_type_id: selectedDefect.action_type_id,
                reference: selectedDefect.reference,
                name: selectedDefect.name,
            },
            initialStatus: {
                errors: {},
            },
        };

        dispatch(formRefreshed(initialForm));

        dispatch(toggleLoading(false));
    } catch ({ response }) {
        dispatch(setAlert('Error populating form.', 'error'));
    }
};

export const refreshLocationFormOptions =
    (selectedLocation) => async (dispatch) => {
        try {
            dispatch(toggleLoading(true));

            dispatch(locationSelected(selectedLocation));

            const initialForm = {
                initialValues: {
                    id: selectedLocation.id,
                    name: selectedLocation.name,
                },
                initialStatus: {
                    errors: {},
                },
            };

            dispatch(formRefreshed(initialForm));

            dispatch(toggleLoading(false));
        } catch ({ response }) {
            dispatch(setAlert('Error populating form.', 'error'));
        }
    };

export const addDocumentToDefect =
    (defect, formValues, objectSrc, isNewDesign) => async (dispatch) => {
        try {
            dispatch(toggleLoading(true));

            const data = new FormData();
            data.append('documentable_id', defect.id);
            data.append('documentable_type', 'App\\Models\\Defect');
            data.append('file', formValues.file);
            data.append('document_type_id', formValues.document_type_id);
            data.append('document_label_id', formValues.document_label_id);
            data.append('name', formValues.file.name);
            const documentData = await documentApi.create(data);
            dispatch(addUploadedPhoto(documentData.data.data.id, objectSrc));

            const message = isNewDesign
                ? 'Finding document added'
                : 'Defect document added';
            dispatch(
                setAlert(message, 'success', 'defect-document')
            );

            dispatch(toggleLoading(false));
        } catch (e) {
            const message = isNewDesign
                ? 'Error adding document to finding.'
                : 'Error adding document to defect.';

            dispatch(
                setAlert(
                    message,
                    'error',
                    'defect-document'
                )
            );
        }
    };

export const deleteDocumentFromDefect = (documentId, isNewDesign) => async (dispatch) => {
    try {
        dispatch(toggleLoading(true));

        await documentApi.delete(documentId);

        const message = isNewDesign
            ? 'Finding document deleted.'
            : 'Defect document deleted.';

        dispatch(
            setAlert(message, 'success', 'defect-document')
        );

        dispatch(toggleLoading(false));
    } catch (e) {
        const message = isNewDesign
                ? 'Error deleting document from finding.'
                : 'Error deleting document from defect.';

        dispatch(
            setAlert(
                message,
                'error',
                'defect-document'
            )
        );
    }
};

export const updateLocation =
    (values, { setSubmitting, setStatus, resetForm }, onSuccess) =>
    async (dispatch, getState) => {
        try {
            const { inspection } = getState().pages.inspectionDetail;

            await defectsApi.updateLocation(values.id, values);

            dispatch(visibleModalToggled(null));
            dispatch(getInspection(inspection.id));

            dispatch(setAlert('Location updated.', 'success'));
            setSubmitting(false);

            resetForm();
            onSuccess();
        } catch ({ response }) {
            setSubmitting(false);

            setStatus({
                errors: responseErrorFormatter(response.data.errors),
            });
        }
    };

export const updateIncludeInReport =
    (payload, defect, resetForm, isNewDesign) => async (dispatch) => {
        try {
            await documentApi.updateIncludeInReport(payload, defect.id);

            dispatch(
                setAlert(
                    'Photo selection updated.',
                    'success',
                    'defect-document'
                )
            );
            if (!isNewDesign) resetForm();
        } catch (response) {
            setAlert(
                'Photos could not be updated.',
                'error',
                'defect-document'
            );
        }
    };
